module.exports = __webpack_public_path__ + "img/lamp-floor.0ef4149c.svg";